<span [class]="'material-symbols-outlined ' + class" [style]="style">
    {{icon}}
</span>